import { bg, line, tx, font, accent, radius, space } from '../theme';

// Accent runs along the bottom edge, not the left.
export default function Stat({ label, value, sub, tone = 'lime', subTone }) {
  const colour = accent[tone] || accent.lime;
  return (
    <div style={{
      background: bg.surface,
      border: `1px solid ${line.DEFAULT}`,
      borderRadius: radius.md,
      padding: `${space.s4}px ${space.s4}px ${space.s5}px`,
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        fontFamily: font.display, fontSize: 10.5, fontWeight: 600,
        letterSpacing: '0.14em', textTransform: 'uppercase',
        color: tx.muted, marginBottom: space.s2,
      }}>
        {label}
      </div>
      <div style={{
        fontFamily: font.data, fontSize: 26, fontWeight: 700,
        lineHeight: 1, letterSpacing: '-0.02em', color: colour,
      }}>
        {value}
      </div>
      {sub && (
        <div style={{
          fontFamily: font.data, fontSize: 11, marginTop: space.s2,
          color: subTone ? (accent[subTone] || tx.muted) : tx.muted,
        }}>
          {sub}
        </div>
      )}
      <div style={{
        position: 'absolute', left: 0, right: 0, bottom: 0,
        height: 2, background: colour,
      }} />
    </div>
  );
}
